import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LANGUAGE } from '@/app.config';
import { LanguageService } from '../services/storage.service';

Vue.use(VueI18n);

/**
 * Cargamos los idiomas
 */
function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};

  // prettier-ignore
  locales.keys().forEach(key => {
    const matched = key.match(/([a-z0-9]+)\./i);

    if (matched && matched.length > 1) {
      const split = matched.input.split('/');
      const locale = split[1];
      const section = matched[1];

      if (!messages[locale]) {
        messages[locale] = {};
      }

      messages[locale][section] = locales(key);
    }
  });

  return messages;
}

const localStorageLanguage = LanguageService.getLanguage();
const navigatorLanguage = navigator.language.split('-');
const defaultLanguage = LANGUAGE.DEFAULT;

const locale = localStorageLanguage || navigatorLanguage[0] || defaultLanguage || 'en';
const fallbackLocale = LANGUAGE.FALLBACK || 'en';
const messages = loadLocaleMessages();

export default new VueI18n({
  locale,
  fallbackLocale,
  messages,
});
